import { put, select } from "redux-saga/effects";

import { UpdateFormBackgroundRequestActionType } from "./../../forms/types";
import { FormsService } from "./../../../services/forms/forms.service";
import { updateFormBackgroundSuccess } from "./../actionCreators";
import { getFormBackgroundStylesChangedValues } from "../../../helpers/dataManipulations";
import { ColorPickerModes } from "../../../libs/Picker/types.d";
import { addAdditionalParams } from "../../../helpers/fileActions";
import { FileService, UploadFileResponse } from "../../../services/file";

export function* newUpdateBackgroundSaga({ payload }: UpdateFormBackgroundRequestActionType) {
    try {
        const userId: string = yield select(state => state.forms.ownerId);
        const formId: string = yield select(state => state.forms.current._id);
        if (payload.background.color.type === ColorPickerModes.IMAGE && payload.background.color.style) {
            const {
                background: {
                    color: { value },
                },
            } = payload;
            const file = addAdditionalParams(value as unknown as File, 0);
            const {
                data: { path },
            }: UploadFileResponse = yield FileService.uploadFile(file, userId, formId);
            const replacedUrl = `${path}`.replace("dl=0", "raw=1");
            const newData = payload.background;
            newData.color = { type: newData.color.type, style: replacedUrl, value: null };

            yield FormsService.newUpdateForm({
                data: getFormBackgroundStylesChangedValues(payload.prevState, newData),
            });
            yield put(updateFormBackgroundSuccess({}));
            return;
        }
        yield FormsService.newUpdateForm({
            data: getFormBackgroundStylesChangedValues(payload.prevState, payload.background),
        });
        yield put(updateFormBackgroundSuccess({}));
    } catch (error) {
        console.log("ERRORIK ", error);

        // yield put(changePaginationActiveStatusFailure(payload));
        // yield put(Handle Error);
    }
}
